<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useStore } from 'dashboard/composables/store';
import SettingsToggleSection from 'dashboard/components-next/Settings/SettingsToggleSection.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();
const store = useStore();

const allowLocalWebhooks = ref(false);

const additionalAttributes = computed(
  () => props.inbox.additional_attributes || {}
);

const syncState = () => {
  allowLocalWebhooks.value = Boolean(
    additionalAttributes.value.allow_local_webhooks
  );
};

watch(() => props.inbox.id, syncState, { immediate: true });
watch(additionalAttributes, syncState);

const updateInbox = async () => {
  try {
    await store.dispatch('inboxes/updateInbox', {
      id: props.inbox.id,
      formData: false,
      channel: {
        additional_attributes: {
          ...additionalAttributes.value,
          allow_local_webhooks: allowLocalWebhooks.value,
        },
      },
    });
    useAlert(t('INBOX_MGMT.DEV_SETTINGS.API.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(error.message || t('INBOX_MGMT.DEV_SETTINGS.API.ERROR_MESSAGE'));
  }
};
</script>

<template>
  <div class="flex flex-col gap-4 mx-6 max-w-4xl">
    <SettingsToggleSection
      v-model="allowLocalWebhooks"
      :header="$t('INBOX_MGMT.DEV_SETTINGS.ALLOW_LOCAL_WEBHOOKS.LABEL')"
      :description="
        $t('INBOX_MGMT.DEV_SETTINGS.ALLOW_LOCAL_WEBHOOKS.DESCRIPTION')
      "
    />
    <div class="flex justify-end">
      <NextButton
        type="button"
        :label="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE')"
        @click="updateInbox"
      />
    </div>
  </div>
</template>
